const accessToken = window.localStorage.getItem('accessToken') !== null
&& window.localStorage.getItem('accessToken') !== ''
  ? window.localStorage.getItem('accessToken') : '';

const refreshToken = window.localStorage.getItem('refreshToken') !== null
&& window.localStorage.getItem('refreshToken') !== ''
  ? window.localStorage.getItem('refreshToken') : '';

const userRole = window.localStorage.getItem('userRole') !== null
&& window.localStorage.getItem('userRole') !== ''
  ? window.localStorage.getItem('userRole') : '';

const accessPathList = window.localStorage.getItem('accessPathList') !== null
&& window.localStorage.getItem('accessPathList') !== ''
  ? window.localStorage.getItem('accessPathList') : '';

const email = window.localStorage.getItem('email') !== null
&& window.localStorage.getItem('email') !== ''
  ? window.localStorage.getItem('email') : '';

const userName = window.localStorage.getItem('userName') !== null
&& window.localStorage.getItem('userName') !== ''
  ? window.localStorage.getItem('userName') : '';


const userId = window.localStorage.getItem('userId') !== null
&& window.localStorage.getItem('userId') !== ''
  ? window.localStorage.getItem('userId') : '';

  /*
const firstName = window.localStorage.getItem('first_name') !== null
&& window.localStorage.getItem('first_name') !== ''
  ? window.localStorage.getItem('first_name') : '';

const lastName = window.localStorage.getItem('last_name') !== null
&& window.localStorage.getItem('last_name') !== ''
  ? window.localStorage.getItem('last_name') : '';
*/

let isLoggedIn = false;
if (window.localStorage.getItem('accessToken') !== null
    && window.localStorage.getItem('accessToken')) {
  isLoggedIn = true;
} else {
  isLoggedIn = false;
}
const user = {
  namespaced: true,
  state: {
    accessToken,
    userRole,
    accessPathList,
    isLoggedIn,
    refreshToken,
    email,
    //firstName,
    //lastName,
    userName,
    userId,
  },
  mutations: {
    updateAccessToken: (oldState, payload) => {
      const newState = oldState;
      newState.accessToken = payload.accessToken;
      return newState;
    },
    updateRefreshToken: (oldState, payload) => {
      const newState = oldState;
      newState.refreshToken = payload.refreshToken;
      return newState;
    },
    updateUserRole: (oldState, payload) => {
      const newState = oldState;
      newState.userRole = payload.userRole;
      return newState;
    },
    updateAccessPathList: (oldState, payload) => {
      const newState = oldState;
      newState.accessPathList = JSON.stringify(payload.accessPathList);
      return newState;
    },
    updateIsLoggedIn: (oldState, payload) => {
      const newState = oldState;
      newState.isLoggedIn = payload.isLoggedIn;
      return newState;
    },
    updateEmail: (oldState, payload) => {
      const newState = oldState;
      newState.email = payload.email;
      return newState;
    },
    retrieveUserData: (oldState, payload) => {
      const newState = oldState;
      //newState.firstName = payload.first_name;
      //newState.lastName = payload.last_name;
      newState.userName = payload.userName;
      newState.userId = payload.userid;      
      return newState;
    },
  },
  actions: {
    updateAccessToken(context, payload) {
      context.commit('updateAccessToken', payload);
    },
    updateRefreshToken(context, payload) {
      context.commit('updateRefreshToken', payload);
    },
    updateUserRole(context, payload) {
      context.commit('updateUserRole', payload);
    },
    updateAccessPathList(context, payload) {
      context.commit('updateAccessPathList', payload);
    },
    updateIsLoggedIn(context, payload) {
      context.commit('updateIsLoggedIn', payload);
    },
    updateEmail(context, payload) {
      context.commit('updateEmail', payload);
    },
    retrieveUserData(context) {
      window.console.log(context);
    },
  },
};

export default user;
